import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldFeedBoardAssoc']),
        getByContactMessage: state => idMessage => {
            return state.objs.filter(assoc => assoc.contactMessage === idMessage);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldFeedBoardAssoc'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldFeedBoardAssoc'])
    },
}